import { CACHE_TTL } from "@serophin/shared";

export { CACHE_TTL, getCacheExpiry } from "@serophin/shared";

/** Every key of this app's cache starts here, so signing out can clear them without touching the auth tokens. */
export const CACHE_PREFIX = "cache:nottldr:";

export const CACHE_TTL_HOUR = CACHE_TTL;
export const CACHE_TTL_DAY = 24 * CACHE_TTL;

export const CACHE_KEYS = {
  profile: `${CACHE_PREFIX}profile`,
  /** Written from the profile and kept without expiry, so settings also work signed out. */
  settings: `${CACHE_PREFIX}settings`,
  tips: `${CACHE_PREFIX}tips`,
  following: `${CACHE_PREFIX}following`,
  articlesRead: `${CACHE_PREFIX}articles:read`,
  bookmarked: `${CACHE_PREFIX}articles:bookmarked`,
  collections: `${CACHE_PREFIX}collections`,
} as const;
